<template>
  <div>
    <div class="el-sign"><el-button v-if="!showButton" type="primary" @click="sign()" style="width: 310px">签名</el-button></div>
    <div>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-image :src="digitalSignImg" v-if="digitalSignImg !== ''" style="height: 124px; width: 310px" />
          <!-- <el-card class="box-card" shadow="always" style="height: 70px; width: 175px; ">
           
          </el-card> -->
        </el-col>
      </el-row>
    </div>
    <el-dialog v-if="!hasPassword" title="初次签名需要设置密码" :visible.sync="passwordVisible" width="20%">
      <div style="display: inline-block">请输入密码<span style="color: red; vertical-align: -10%"> *</span>：</div>
      <div class="sign-password">
        <el-input placeholder="请输入密码" v-model="setPassword"></el-input>
      </div>
      <div style="display: inline-block">确认密码<span style="color: red; vertical-align: -10%; margin-left: 15px"> *</span>：</div>
      <div class="sign-password">
        <el-input placeholder="请再次输入密码" v-model="confirmPassword"></el-input>
      </div>
      <div class="first-confirm">
        <el-button type="primary" @click="firstConfirm()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog v-else title="请输入密码" :visible.sync="passwordVisible" width="20%">
      <div class="common-password">
        <el-input placeholder="请输入签名密码" v-model="password"></el-input>
      </div>
      <div class="confirm">
        <el-button type="danger" plain @click="changePassword()">修改密码</el-button>
        <el-button type="primary" @click="confirm()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改电子签名密码" :close-on-click-modal="false" :visible.sync="showChangePassword" width="400px" append-to-body>
      <div style="display: inline-block; margin-left: 28px">原密码<span style="color: red; vertical-align: -10%"> *</span>：</div>
      <div class="sign-password">
        <el-input placeholder="请输入原密码" v-model="oldPassword"></el-input>
      </div>
      <div style="display: inline-block; margin-left: 28px">新密码<span style="color: red; vertical-align: -10%"> *</span>：</div>
      <div class="sign-password">
        <el-input placeholder="请输入新密码" v-model="newPassword"></el-input>
      </div>
      <div style="display: inline-block; margin-left: 15px">确认密码<span style="color: red; vertical-align: -10%"> *</span>：</div>
      <div class="sign-password">
        <el-input placeholder="确认密码必须与新密码一致" v-model="confirmNewPassword"></el-input>
      </div>
      <div class="first-confirm">
        <el-button type="primary" @click="ConfirmPassword()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AceElectronicSignature",
  data() {
    return {
      showChangePassword: false,
      passwordVisible: false,
      hasPassword: false, //初始化判断是否有密码
      password: "", //输入的密码
      setPassword: "", //设置密码
      confirmPassword: "", //确认密码
      oldPassword: "", //旧密码
      newPassword: "", //新密码
      confirmNewPassword: "", //确认密码
      // userId: "5c75424d59084a6a95387d736c1dcb10",
      // formId: "123456",
      // categoryId: "",
      // appId: "dv_test_app",
      // document: "",
      digitalSignImg: "", //电子签名图片
      showButton: false,
      hasSignInfo: false,
    };
  },
  props: {
    userId: {
      type: String,
      default: "",
    },
    formId: {
      type: String,
      default: "",
    },
    appId: {
      type: String,
      default: "",
    },
    document: {
      type: String,
      default: "",
    },
    categoryId: {
      type: String,
      default: "",
    },
  },
  components: {},
  mounted() {},
  created() {
    // console.log("userid", this.document, this.userId);
    this.init();
  },
  methods: {
    //初始化判断是否有签名信息
    init() {
      this.getHasSignDocument();
    },
    //签名
    sign() {
      this.passwordVisible = true;
      this.getDigitalSignature();
    },
    //确认密码
    ConfirmPassword() {
      this.updateDigitalSignaturePassword();
    },
    //修改密码
    changePassword() {
      this.showChangePassword = true;
    },
    //修改密码
    updateDigitalSignaturePassword() {
      this.$http({
        url: this.$http.adornUrl("/sign/digitalSignature/action/updateDigitalSignaturePassword"),
        method: "post",
        data: this.$http.adornData({
          userId: this.userId,
          password: this.oldPassword,
          newPassword: this.newPassword,
        }),
      }).then((result) => {
        // console.log("xinma", result);
        if (result.data.code === 40000) {
          this.showChangePassword = false;
          this.messageBox = this.$message.success("密码更改成功！");
          this.oldPassword = "";
          this.newPassword = "";
          this.confirmNewPassword = "";
        } else {
          this.messageBox && this.messageBox.close();
        }
      });
    },
    //设置密码确认
    firstConfirm() {
      if (this.setPassword !== this.confirmPassword) {
        alert("两次输入的密码不一致，请重新输入！");
        this.confirmPassword = "";
      } else {
        if (this.setPassword.length !== 8) {
          alert("密码不是8位数，请重新输入！");
          this.setPassword = "";
          this.confirmPassword = "";
        } else {
          this.setDigitalSignature();
        }
      }
    },
    //输入密码确认
    confirm() {
      this.checkPassword();
    },
    //验证密码是否正确
    async checkPassword() {
      //   console.log("formId", this.formId);
      let result = await this.$http({
        url: this.$http.adornUrl("/sign/digitalSignature/action/signDocument"),
        method: "post",
        data: {
          password: this.password,
          formId: this.formId,
          categoryId: this.categoryId,
          appId: this.appId,
          text1: "",
          text2: "",
          document: this.document,
          userId: this.userId,
        },
      });
      if (result.data.code === 40000) {
        if (result.data.result.hasImg === 1) {
          // this.digitalSignImg = this.$http.adornUrl(`/sign/digitalSignature/action/download?userId=${this.userId}&t=${new Date().getTime()}`,false);
          this.getDigitalSignImg();
          // this.digitalSignImg = this.$http.adornUrl("/sign/digitalSignature/action/download?userId=5c75424d59084a6a95387d736c1dcb10" + "&t=" + new Date().getTime(), false);
          this.passwordVisible = false;
          this.showButton = true;
        }
        // this.getDigitalSignImg();
      } else if (result.data.code === 40002) {
        this.messageBox && this.messageBox.close();
        this.messageBox = this.$message.error(result.data.msg);
        // if (result.data.innerCode === "SIGN-S00004") {
        //   this.password = "";
        //   this.messageBox = this.$message.error(result.data.msg);
        // } else {
        //   this.messageBox && this.messageBox.close();
        //   this.messageBox = this.$message.error(result.data.msg);
        // }
      } else {
        this.messageBox && this.messageBox.close();
        this.messageBox = this.$message.error(result.data.msg);
      }
    },
    //初始化判断是否已经有正确可用的签名信息
    async getHasSignDocument() {
      let result = await this.$http({
        url: this.$http.adornUrl("/sign/digitalSignature/action/hasSignDocument"),
        method: "get",
        params: this.$http.adornParams({
          userId: this.userId,
          formId: this.formId,
          appId: this.appId,
        }),
      });
      if (result.data.code === 40000) {
        //如果有签名信息，直接展示
        if (result.data.result.hasSignInfo) {
          this.showButton = true;
          this.getDigitalSignImg();
          // this.digitalSignImg = this.$http.adornUrl("/sign/digitalSignature/action/download?userId=5c75424d59084a6a95387d736c1dcb10" + "&t=" + new Date().getTime(), false);
        }
      } else {
        this.messageBox && this.messageBox.close();
        // this.messageBox = this.$message.error(result.data.msg);
      }
    },
    //判断是否有电子签名
    async getDigitalSignature() {
      let result = await this.$http({
        url: this.$http.adornUrl("/sign/digitalSignature/action/hasDigitalSignature/" + this.userId),
        method: "get",
      });
      if (result.data.code == 40000) {
        if (result.data.result == true) {
          this.hasPassword = true;
        } else {
          this.hasPassword = false;
        }
      } else {
        this.messageBox && this.messageBox.close();
        this.messageBox = this.$message.error(result.data.msg);
      }
    },
    //给用户创造电子签名
    async setDigitalSignature() {
      let result = await this.$http({
        url: this.$http.adornUrl("/sign/digitalSignature/action/createDigitalSignature"),
        method: "post",
        data: {
          userId: this.userId,
          password: this.setPassword,
        },
      });
      if (result.data.code === 40000) {
        this.messageBox = this.$message.success("密码设置成功！");
        this.setPassword = "";
        this.confirmPassword = "";
        this.passwordVisible = false;
      } else {
        this.messageBox && this.messageBox.close();
        this.messageBox = this.$message.error(result.data.msg);
      }
    },
    //获取签名图片
    async getDigitalSignImg() {
      let result = await this.$http({
        url: this.$http.adornUrl("/sign/digitalSignature/action/download"),
        method: "get",
        params: this.$http.adornParams({
          userId: this.userId,
        }),
      });
      if (result.status == 200) {
        this.digitalSignImg = this.$http.adornUrl("/sign/digitalSignature/action/download?userId=" + this.userId + "&t=" + new Date().getTime(), false);
      }
    },
  },
};
</script>

<style lang="scss">
.el-sign {
}
.el-card__body {
  padding: 0 !important;
}
.sign-password {
  display: inline-block;
  width: 500px;
  margin: 10px auto;
}
.first-confirm {
  margin: 20px 20px 0 0;
  float: right;
}
.common-password {
  width: 500px;
  margin: 0 auto;
}
.confirm {
  margin: 20px 55px 0 0;
  float: right;
}
</style>
